import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different signin action types
*/
let initialstate = {
  isLoading: false,
  customers: [],
  pagination: {},
  searchText: '',
}
export default function customer_operations(
  state = { ...initialstate },
  action
) {
  switch (action.type) {
    case ActionType.CUSTOMER_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.CUSTOMER_LIST:
      return {
        ...state,
        isLoading: action.isLoading,
        customers: action.customers,
        pagination: action.pagination,
        searchText: action.searchText,
      }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
